import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for Hero:
 * slots:
 * - container
 * - assetContainer
 * - darkenLayerBottom
 * - darkenLayerLeft
 * - textContainer
 * - heading
 * - copy
 * variants:
 * - textPosition: bottom-left | center-left | center-center
 * - darken: 0% | 40% | 80%
 * compoundVariants:
 * - if textPosition is bottom-left or center-left and darken is 40% or 80%, darkenLayerLeft is gradient.left.darken-40
 * - if textPosition is center-center and darken is 40% or 80%, darkenLayerLeft is gradient.left.darken-80
 * defaultVariants:
 * - textPosition: center-center
 * - darken: 0%
 */
export default defineSlotRecipe({
    slots: [
        'container',
        'assetContainer',
        'darkenLayerBottom',
        'darkenLayerLeft',
        'textContainer',
        'heading',
        'copy'
    ],
    base: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'spacing-24', s: 'spacing-40'},
            position: 'relative',
            width: '100vw',
            height: 'calc(100vh - var(--header-height, 0px))',
            overflow: 'hidden',
            px: {base: 'spacing-24', md: 'spacing-90'},
            paddingBlockStart: {base: 'spacing-48', md: 'spacing-80'},
            paddingBlockEnd: {base: 'spacing-24', md: 'spacing-80'}
        },
        assetContainer: {
            position: 'absolute',
            inset: 0,
            overflow: 'hidden'
        },
        darkenLayerBottom: {
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none'
        },
        darkenLayerLeft: {
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none'
        },
        textContainer: {
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            rowGap: 'spacing-8',
            maxW: 'module-content-max-width'
        },
        heading: {
            textStyle: 'display.largeItalic'
        },
        copy: {
            color: 'text.primary',
            textStyle: 'body.large'
        }
    },
    variants: {
        textPosition: {
            'bottom-left': {
                container: {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start'
                },
                textContainer: {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start'
                },
                heading: {
                    alignment: 'left'
                },
                copy: {
                    alignment: 'left',
                    textAlign: 'start'
                }
            },
            'center-left': {
                container: {
                    justifyContent: 'center',
                    alignItems: 'flex-start'
                },
                textContainer: {
                    justifyContent: 'center',
                    alignItems: 'flex-start'
                },
                heading: {
                    alignment: 'left'
                },
                copy: {
                    alignment: 'left',
                    textAlign: 'start'
                }
            },
            'center-center': {
                container: {
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                textContainer: {
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                heading: {
                    alignment: 'center'
                },
                copy: {
                    alignment: 'center',
                    textAlign: 'center'
                }
            }
        },
        darken: {
            '0%': {
                darkenLayerBottom: {
                    bg: 'transparent'
                },
                darkenLayerLeft: {
                    bg: 'transparent'
                }
            },
            '40%': {
                darkenLayerBottom: {
                    bg: 'gradient.bottom.darken-40'
                }
            },
            '80%': {
                darkenLayerBottom: {
                    bg: 'gradient.bottom.darken-80'
                }
            }
        }
    },
    compoundVariants: [
        {
            textPosition: ['bottom-left', 'center-left'],
            darken: '40%',
            css: {
                darkenLayerLeft: {
                    bg: 'gradient.left.darken-40'
                }
            }
        },
        {
            textPosition: ['bottom-left', 'center-left'],
            darken: '80%',
            css: {
                darkenLayerLeft: {
                    bg: 'gradient.left.darken-40'
                }
            }
        },
        {
            textPosition: 'center-center',
            darken: '40%',
            css: {
                darkenLayerLeft: {
                    bg: 'gradient.left.darken-80'
                }
            }
        },
        {
            textPosition: 'center-center',
            darken: '80%',
            css: {
                darkenLayerLeft: {
                    bg: 'gradient.left.darken-80'
                }
            }
        }
    ],
    defaultVariants: {
        textPosition: 'center-center',
        darken: '0%'
    }
})
